/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * POAM update request
 * @export
 * @interface POAMUpdateRequest
 */
export interface POAMUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof POAMUpdateRequest
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof POAMUpdateRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof POAMUpdateRequest
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof POAMUpdateRequest
     */
    priority?: string;
    /**
     * 
     * @type {Date}
     * @memberof POAMUpdateRequest
     */
    dueDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof POAMUpdateRequest
     */
    remarks?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof POAMUpdateRequest
     */
    relatedFindings?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof POAMUpdateRequest
     */
    importSspId?: string;
    /**
     * 
     * @type {string}
     * @memberof POAMUpdateRequest
     */
    budget?: string;
}

/**
 * Check if a given object implements the POAMUpdateRequest interface.
 */
export function instanceOfPOAMUpdateRequest(value: object): value is POAMUpdateRequest {
    return true;
}

export function POAMUpdateRequestFromJSON(json: any): POAMUpdateRequest {
    return POAMUpdateRequestFromJSONTyped(json, false);
}

export function POAMUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): POAMUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'status': json['status'] == null ? undefined : json['status'],
        'priority': json['priority'] == null ? undefined : json['priority'],
        'dueDate': json['dueDate'] == null ? undefined : (new Date(json['dueDate'])),
        'remarks': json['remarks'] == null ? undefined : json['remarks'],
        'relatedFindings': json['relatedFindings'] == null ? undefined : json['relatedFindings'],
        'importSspId': json['importSspId'] == null ? undefined : json['importSspId'],
        'budget': json['budget'] == null ? undefined : json['budget'],
    };
}

export function POAMUpdateRequestToJSON(json: any): POAMUpdateRequest {
    return POAMUpdateRequestToJSONTyped(json, false);
}

export function POAMUpdateRequestToJSONTyped(value?: POAMUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'description': value['description'],
        'status': value['status'],
        'priority': value['priority'],
        'dueDate': value['dueDate'] == null ? undefined : ((value['dueDate']).toISOString()),
        'remarks': value['remarks'],
        'relatedFindings': value['relatedFindings'],
        'importSspId': value['importSspId'],
        'budget': value['budget'],
    };
}

